import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthService {
  private apiUrl: string;
  private largeApiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.apiUrl;
    this.largeApiUrl = environment.LargeapiUrl;
    this.largeApiUrl = environment.LargeapiUrl;
  }


  tokenExchange(code = null) {
    const url = this.apiUrl + '/auth/tokenExchange';
    return this.http.post<any>(url, { code } );
  }
  getNewAccessToken(refresh_token = null) {
    const url = this.apiUrl + '/auth/refreshToken';
    return this.http.get<any>(url, { params: { refresh_token } });
  }
  getEnloToken() {
    const url = this.largeApiUrl + '/auth/token';
    return this.http.post<any>(url, {} );
  }

}
